export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/7f8fea9003e1a4e1e0e93817290b5b81.png";